export const Bio = {
  name: "Hamza Khan",
  roles: [
    "Python Scripting",
    "Backend Development",
    "API Design & Integration",
    "Web Scraping & Automation",
    "Data Analysis",
    "AI/ML",
    "Generative AI / Agentic AI",
],
  description:
    "A passionate Python developer skilled in in Backend Development, API Design / Integration, Data Scraping, Automation, and AI/ML (including Generative AI and Agentic AI) Gained hands-on experience through freelance projects and internships. Focused on building scalable backend systems, AI-powered applications, and automation tools to solve practical problems. Always looking to learn new technologies and grow in my career.",
  github: "https://github.com/hamza08003",
  resume: "https://drive.google.com/file/d/1_h7eTHZimaZmzguX9p-AgwY0xODpWSJd/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/hamza2082003/",
  twitter: "https://twitter.com/hamza08003",
  insta: "https://www.instagram.com/hamza08003",
};

export const skills = [
  {
    title: "AI (ML - Gen AI)",
    skills: [
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Pandas",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/pandas/pandas-original.svg",
      },
      {
        name: "NumPy",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original.svg",
      },
      {
        name: "Matplotlib",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKt9fsfQ8qST4DCnH9EpXIc2f1pEcaZutung&s.png",
      },
      {
        name: "Scikit-learn",
        image: "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
      },
      {
        name: "TensorFlow",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tensorflow/tensorflow-original.svg",
      },
      {
        name: "OpenAI API",
        image: "https://seeklogo.com/images/O/openai-logo-8B9BFEDC26-seeklogo.com.png",
      },
      {
        "name": "LangChain",
        "image": "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/langchain.png",
      },
      {
        name: "Hugging Face",
        image: "https://huggingface.co/front/assets/huggingface_logo.svg",
      },    
      {
        name: "OpenCV",
        image: "https://icon2.cleanpng.com/20180509/vkw/kisspng-opencv-computer-vision-library-robot-operating-sys-visceral-impact-introduction-5af2a4b8b15554.2494201115258513207264.jpg",
      },
      {
        name: "Gymnasium",
        image: "https://gymnasium.farama.org/_static/img/gymnasium_black.svg",
      },
    ],
  },
  {
    title: "Data Scraping & Web   Automation",
    skills: [
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
      },
      {
        name: "Selenium",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Selenium_Logo.png",
      },
      {
        name: "Scrapy",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgRI1buEg7S46SCVE_a_l9ChkubGb_2O_PdKLaH0tXP3a_y-ba6kvc63Th4x5hBccfKKQ&usqp=CAU.png",
      },
      {
        name: "Puppeteer",
        image: "https://user-images.githubusercontent.com/10379601/29446482-04f7036a-841f-11e7-9872-91d1fc2ea683.png",
      },
      {
        name: "Playwright",
        image: "https://playwright.dev/img/playwright-logo.svg",
      },
      {
        name: "BeautifulSoup",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6SNJ45IQV3XLYEwFyJoSRBqOHWjYsi-Sf5A&s.png",
      },
      {
        name: "Requests",
        image: "https://raw.githubusercontent.com/psf/requests/master/ext/requests-logo.png",
      },
      {
        name: "PyAutoGUI",
        image: "https://thumbs.dreamstime.com/z/robot-computer-mouse-13419240.jpg",
      },
    ],
  },
  {
    title: "API Design / Integration",
    skills: [
      {
        name: "FastAPI",
        image: "https://cdn.worldvectorlogo.com/logos/fastapi.svg",
      },
      {
        name: "Flask",
        image: "https://cdn.worldvectorlogo.com/logos/flask.svg",
      },
      {
        name: "Instagram API",
        image: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png",
      },
      {
        name: "TikTok API",
        image: "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/tiktok.svg",
      },
      {
        name: "Twitter API",
        image: "https://cdn-icons-png.flaticon.com/512/733/733579.png",
      },
      {
        name: "Discord API",
        image: "https://cdn-icons-png.flaticon.com/512/2111/2111370.png",
      },
      {
        name: "Google Cloud Platform",
        image: "https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg",
      },
      // {
      //   name: "Meta APIs",
      //   image: "https://crystalpng.com/wp-content/uploads/2025/02/meta_logo.png",
      // },
      {
        name: "Postman",
        image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image: "https://cdn.worldvectorlogo.com/logos/css-3.svg",
      },
      {
        name: "Tailwind CSS",
        image: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "React.js",
        image: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
      },
      {
        name: "TypeScript",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
      {
        name: "Canva",
        image: "https://public.canva.site/logo/media/dfb96cc174513093cd6ed61489ccb750.svg",
      },
      {
        name: "Streamlit",
        image: "https://seeklogo.com/images/S/streamlit-logo-1A3B208AE4-seeklogo.com.png",
      },
      {
        "name": "Tkinter",
        "image": "https://w7.pngwing.com/pngs/679/344/png-transparent-wing-ide-integrated-development-environment-python-computer-software-eric-raspberry-miscellaneous-monochrome-computer-program.png"
      },
    ],
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "SQLite",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/97/Sqlite-square-icon.svg",
      },
      {
        name: "Redis",
        image: "https://cdn4.iconfinder.com/data/icons/redis-2/1451/Untitled-2-512.png",
      },
      {
        "name": "Milvus",
        "image": "https://miro.medium.com/v2/resize:fit:2400/1*-VEGyAgcIBD62XtZWavy8w.png",
      },
      // {
      //   "name": "Pinecone",
      //   "image": "https://png.pngtree.com/png-vector/20240705/ourmid/pngtree-vector-colored-pine-cone-logo-illustration-png-image_7209756.png"
      // },
    ],
  },
  {
    title: "Tools and Softwares",
    skills: [
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg",
      },
      {
        name: "Conda",
        image: "https://www.clipartmax.com/png/middle/234-2342873_anaconda-on-twitter-anaconda-python.png",
      },
      {
        name: "Netlify",
        image: "https://w7.pngwing.com/pngs/600/484/png-transparent-netlify-static-web-page-gulp-js-github-github-blue-angle-logo-thumbnail.png",
      },
      {
        name: "Jupyter Notebook",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/jupyter/jupyter-original-wordmark.svg",
      },
      {
        "name": "MS Word",
        "image": "https://upload.wikimedia.org/wikipedia/commons/0/08/Microsoft_Word_logo_%282013-2019%29.png",
        },
        {
          name: "MS Excel",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1GqgvMtiNSVQAj0uRTkli20ydHem_vbrCRfG80E19I7aXX7R4GDHB41iUah0sibLMMQc&usqp=CAU.png",
        },
        {
          name: "MS PowerPoint",
          image: "https://images.seeklogo.com/logo-png/29/2/microsoft-powerpoint-2013-logo-png_seeklogo-298302.png",
        },
        // {
        //   name: "Figma",
        //   image: "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
        // },
    ],
  },
];
;

export const experiences = [
  {
    id: 0,
    img: "https://www.bolnews.com/wp-content/uploads/2022/12/FotoJet-6-184.jpg",
    role: "AI - Machine Learning Intern",
    company: "NEPNIC - Punjab Information Technology Board (PITB)",
    date: "Apr 2022 - Sep 2022",
    desc: "During my internship as an AI & Machine Learning internee at NEPNIC-Taxila under the Punjab Information Technology Board (PITB), I had the opportunity to learn and contribute to projects in the field of machine learning by working with a diverse team of experts. My key responsibilities included developing machine learning models using sickit-learn, performing data analysis, preprocessing and feature engineering for model training, implementing computer vision techniques, testing and refining models for optimal performance, and collaborating with team members on project development. Additionally, I dedicated time outside of the internship to further expand my skills in Computer Vision.",
    skills: [
      "Pandas",
      "Numpy",
      "Matplotlib",
      "Sickit-learn",
      "Data Cleaning & Preprocessing",
      "Exploratory Data Analysis",
      "Statistical Modeling",
      "Correlation Analysis",
      "Feature Engineering",
      // "Dimensionality Reduction",
      "Model Evaluation & Validation",
    ],
    doc: "",
  },
  {
    id: 0,
    img: "https://logos-world.net/wp-content/uploads/2021/04/Upwork-Symbol.png",
    role: "Web Automation, Social Media Bots, Data Scraping, Data Analysis - Generative AI",
    company: "Upwork",
    date: "2023 - Present",
    desc: "Since 2023, I've specialized in Web Automation, Large-Scale Data Scraping, and Generative AI solutions on Upwork. My projects include building high performance scrapers (Selenium/Playwright), automating workflows, and developing AI tools using LangChain & Open Source LLMs. I also integrate and automate social media platforms (Instagram, Twitter/X, Discord, TikTok) via their APIs for tasks like content scheduling, analytics, and bot development. For cloud-based solutions, I use Google Cloud Platform (GCP) service and APIs. Additionally, I analyze scraped data to extract business insights and train custom models.",
    skills: [
      "Selenium",
      "Scrapy",
      "Playwright",
      "Puppeteer",
      "Meta (Social Media APIs)",
      "Instagram Automation",
      "Twitter/X API",
      "Discord Bots",
      "TikTok API / Automation",
      "Google Cloud Platform",
      "Data Analysis",
      "LangChain",
      "OpenAI API",
      "Hugging Face",
      "Pinecone",
      "Milvus",
    ],
  },
  {
    id: 1,
    img: "https://e7.pngegg.com/pngimages/247/318/png-clipart-fiverr-new-logo-tech-companies.png",
    role: "Python Scripting - Web Development",
    company: "Fiverr",
    date: "2022 - 2023",
    desc: "I offered Python scripting, Small Scale Web Development, and coding lessons on Fiverr. My work included building automation scripts and web apps (React/Flask). I also taught Python fundamentals to beginners, helping them grasp core programming concepts through practical projects.",
    skills: [
      "Selenium",
      "Scrapy",
      "Playwright",
      "Puppeteer",
      "BeautifulSoup",
      "Google Cloud Platform",
      "Social Media APIs",
      "FastAPI",
      "Flask",
      "HTML/CSS/JS/TS",
      "React",
      "Tailwind",
      "Bootstrap",
      "Streamlit",
      "Tkinter",
      "MongoDB",
      "SQLite/MySQL",
    ],
  },
  {
    id: 2,
    img: "https://dailyausaf.com/en/wp-content/uploads/2024/08/IMG_3642-1024x532.jpeg",
    role: "Telecom Systems Intern",
    company: "Pakistan Civil Aviation Authority (CAA)",
    date: "Aug 2024 - Sep 2024",
    desc: "During my internship at the Civil Aviation Authority as a telecom engineer, I had the opportunity to visit and explore various telecommunications and radar systems under the guidance of experienced professionals. These tours provided me with hands-on exposure to the operation, maintenance, and integration of critical systems such as antennas, radar, and communication networks used in air traffic control and flight operations. I observed demonstrations of radar calibration, antenna alignment, and network troubleshooting, which helped me understand how these systems function in real-world scenarios. Additionally, I assisted in minor tasks during system inspections and testing. This experience allowed me to gain practical insights into the challenges and solutions involved in aviation telecommunications, enhancing my technical knowledge and skills in the field.",
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://www.clipartmax.com/png/middle/204-2047602_uet-taxila-logo.png",
    school: "University of Engineering and Technology (UET) Taxila",
    date: "Aug 2021 - Present",
    grade: "3.13 CGPA (Current)",
    desc: "I am currently pursuing a Bachelor's degree in Telecommunication Engineering at the University of Engineering and Technology (UET) Taxila. My coursework includes course subjects such as wireless communication systems, digital signal processing, computer communication networks, next generation networks, data structures and algorithms and machine learning. I am actively involved in various academic projects and research initiatives related to telecommunication wireless systems and technologies.",
    degree: "Bachelor of Science in Telecommunication Engineering",
  },
  {
    id: 1,
    img: "https://www.dailyparliamenttimes.com/wp-content/uploads/2020/04/pic6-25.jpg",
    school: "FG Degree College for Men, Wah Cantt",
    date: "Aug 2019 - Apr 2021",
    grade: "75.23%",
    desc: "Completed my FSc. Pre-Engineering with a focus on Physics, Chemistry, and Mathematics. Actively participated in science fairs and team projects, fostering collaboration and time management abilities.",
    degree: "FSc. Pre-Engineering",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSg9OkwIB2jjNOndk5_dNYBxPhIpWqS3NIzLQ&s.png",
    school: "HMC Boys High School, Taxila", 
    date: "Mar 2017 - Apr 2019",
    grade: "93.18%",
    desc: "Completed Matriculation with 93.18%, ranking among the top performers in my cohort. Excelled in core subjects like Mathematics, Physics, and Computer Science, where I first developed a passion for problem-solving and algorithmic thinking. Participated in regional science competitions and led classroom projects, honing leadership and analytical skills that later fueled my transition into tech",
    degree: "Matriculation",
  },
];

export const projects = [
  {
    id: 9,
    title: "KYC Verification System",
    date: "May 2024 - Jul 2024",
    description:
      "A KYC Verification System using Python and Streamlit, developed as a cost-effective alternative to expensive third-party services. The system automates document and face verification by integrating Google Cloud Vision for OCR and OpenAI GPT-3 for name and address extraction from ID documents and utility bills. It also includes facial recognition that matches live video with ID photos. Built with Streamlit, it offers a seamless, user-friendly interface. I will be extending this system using FastAPI and Next.js to make it easily integratable into other applications.",
    image:
      "https://www.crif.digital/media/gejfxclo/what-is-kyc-verification.jpg?anchor=center&mode=crop&width=706&height=382&rnd=133161188295530000.png",
    tags: [
      "Google Cloud Vision AI",
      "Tesseract OCR",
      "Face Recognition",
      "OpenAI API",
      "Streamlit",
      "FastAPI",
      "OpenCV",
      "WebRTC",
      "Docker",
    ],
    categories: ["artificial intelligence", "automation"],
    github: "https://github.com/hamza08003/KYC-Verication-System_Python-Streamlit",
    member: [
      {
        name: "Hamza Khan",
        img: "https://avatars.githubusercontent.com/u/105966376?v=4",
        linkedin: "https://www.linkedin.com/in/hamza2082003/",
        github: "https://github.com/hamza08003",
      },
      {
        name: "Hamza Tariq",
        img: "https://avatars.githubusercontent.com/u/90743729?v=4",
        linkedin: "https://www.linkedin.com/in/hamza-tariq-butt/",
        github: "https://github.com/hamzabu004",
      },
    ],
  },
  {
    id: 0,
    title: "IG Automated Actions Bot",
    date: "Sep 2024 - Nov 2024",
    description:
      "An Instagram Automation Bot built using Python, with libraries like instagrapi, BeautifulSoup, moviepy, pandas and multiprocessing to handle multiple Instagram accounts. The bot automates a wide range of actions, including liking and commenting on feed posts, reels, and stories, as well as uploading photos, videos, albums, and stories with features like music integration, usertags, locations, and hashtags. It supports parallel account logins with proxy support for enhanced security and emulates real devices by fetching random device information and setting custom user agents to avoid detection. The tool processes Excel files for batch operations and offers an interactive menu for managing all actions. Designed with robust error handling and logging, this project demonstrates my expertise in Python programming, API integration, and automation.",
    image:
      "https://platypusreviews.com/wp-content/uploads/2020/10/rsz_instagram_bots-1024x585.jpg",
    tags: [
      "Instagram Automation",
      "API Integration",
      "Instagrapi", 
      "Requests",
      "BeautifulSoup",
      "Pandas", 
      "Moviepy",
      "Multiprocessing",
    ],
    categories: ["automation", "data scraping"],
    github: "https://github.com/hamza08003/IG-Automated-Actions-BOT",
    webapp: "https://podstream.netlify.app/",
  },
  {
    id: 1,
    title: "Realtime Facial Emotion Recognition",
    date: "March 2025 - Present",
    description:
      "A Real time facial emotion recognition system to detect seven emotions—neutral, happiness, sadness, surprise, fear, disgust, and anger—from images and live video using the AffectNet dataset. By designing a custom deep learning model, ResEmoteNet, I employed neural network architecture design to integrate convolutional layers, Squeeze-and-Excitation blocks, and residual connections, achieving high accuracy on the AffectNet-7 dataset Using computer vision thorough OpenCV, I implemented face detection and image processing to prepare data for training and real-time analysis. Then developed Streamlit web app that supports image uploads, ZIP file handling, and webcam input, displaying results. Real-time processing and error handling ensured smooth performance, with file management for storing results",
    image:
      "https://www.researchgate.net/publication/329290966/figure/fig1/AS:730534921637890@1551184506993/Seven-basic-human-emotions.png",
    tags: [
      "Pandas",
      "NumPy",
      "Matplotlib",
      "PIL",
      "Sickit-learn",
      "PyTorch",
      "Torchvision",
      "OpenCV",
      "Streamlit",
      "HTML/CSS",
    ],
    categories: ["artificial intelligence"],
    github: "https://github.com/hamza08003/realtime-fer",
    webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Virtual Voice Assistant",
    date: "Dec 2022 - Feb 2023",
    description:
      "Developed an advanced voice assistant that processes voice commands to execute tasks like launching applications, performing web searches, and retrieving real-time data. Voice recognition enabled accurate input capture, while text-to-speech processing delivered clear responses, enhancing user interaction design. System automation facilitated opening tools such as calculators, cameras, and text editors, and web interaction supported searches on Google, YouTube, and Wikipedia, alongside fetching weather updates and trending movies. Natural language processing and command parsing interpreted diverse commands, enabling email and WhatsApp messaging, plus AI-generated answers via OpenAI integration. Error handling ensured reliable operation, managing unrecognized inputs effectively.",
    image:
      "https://www.addevice.io/storage/ckeditor/uploads/images/6405c61c9dfb8_how.to.create.virtual.assistant.app.1920.1080.png",
    tags: [
      "speech_recognition", 
      "pyttsx3", 
      "PyAutoGUI",
      "OpenAI API", 
      "Natural Language Processing", 
      "System Automation"
    ],
    categories: ["python tools"],
    github: "https://github.com/hamza08003/Advanced-Voice-Assistant-Python",
  },
  {
    id: 3,
    title: "DeepCrawl Vision",
    date: "Feb 2025 - Present",
    description:
      "Developed DeepCrawl Vision, a versatile pipeline for deep website crawling and advanced image analysis. It recursively scrapes websites to extract data like page URLs and image URLs etc enabling applications such as content analysis and data mining. The system asynchronously downloads images with rate-limited precision, organizes them by crawl depth, and deduplicates using perceptual hashing to retain top-quality versions. DeepFace powers face detection using RetinaFace and ArcFace for face vector embedding extraction, with results stored in structured CSVs. Featuring GPU-accelerated batch processing and detailed Excel outputs, this project excels in scalable web scraping, image processing, and machine learning, adaptable for facial recognition, data mining, and more.",
    image:
      "https://media.istockphoto.com/id/1453552886/vector/web-crawler-crawling-website-data-server-on-computer-internet-with-modern-flat-style.jpg?s=612x612&w=0&k=20&c=0IA7Qj6w7DOn3qqKSA-fO9j3ANbuhdDSs4fM6L0Y1js=",
    tags: [
      "Deep Web Crawling",
      "Crawl4AI",
      "openpyxl", 
      "PlayWright",
      "asyncio", 
      "aiofiles",
      "aiohttp",
      "imagehash",
      "DeepFace",
      "Tensorflow",
    ],
    categories: ["automation", "data scraping", "artificial intelligence"],
    github: "https://github.com/hamza08003/Deep-Link-Harvester",
  },
  {
    id: 10,
    title: "Dual Audio Capture Tool",
    date: "Nov 2024 - Dev 2024",
    description:
      "A real-time audio monitoring tool built in Python that simultaneously captures and analyzes audio from both a microphone and system loopback device using the pyaudiowpatch library. It intelligently detects the current active audio source—whether it's microphone input, system audio, or silence—by calculating the Root Mean Square (RMS) energy of audio frames. The tool dynamically switches its output based on detected audio activity and prints the current source accordingly. Designed with performance in mind, the system uses buffered audio reads, silence detection thresholds, and CPU load minimization strategies like timed sleeps. It leverages NumPy for efficient signal processing and supports configurable channel types (mono/stereo) and sample rates. This tool is useful for tasks like live monitoring, audio switching automation, and building intelligent voice-aware systems.",
    image:
      "https://static.vecteezy.com/system/resources/previews/055/824/182/non_2x/speech-to-text-concept-speech-recognition-speech-scanning-voice-to-text-speech-recognition-service-user-recognizes-voice-and-translates-to-text-with-speaker-flat-design-illustration-vector.jpg",
    tags: [
      "OpenAI Whisper",
      "pyaudiowpatch",
      "soundfile", 
      "pydub",
      "Numpy",
      "Threading",
    ],
    categories: ["python tools"],
    github: "https://github.com/hamza08003/pyaudiowpatch-dual-audio-capture-and-transcription",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
